import { Analytics } from '../../pages';
import { CampaignWebhooks } from '../../pages';
import { CampaignCallerAgents } from '../../pages';
// import { MessagesForContact } from '../../pages';
import { PromptsForCampaign } from '../../pages';
import { CampaignMonitoring } from '../../pages';
import { OrganizationSecrets } from '../../pages';
import { DialerScheduleSettings } from '../../pages';
import { ContactStateSettings } from '../../pages';
import { Contacts, ContactsImport } from '../../pages';
import { Tasks, Campaigns, GeneralMonitoring } from '../../pages';
// import { Statistics, Webhooks } from '../../pages';

export const getRoutes: (meta: AppMetaType) => AppRouteType[] = meta => {
  const singleCampaignId = meta.initialCampaignFilter;

  return [
    {
      icon: 'chart',
      url: '/analytics',
      menuTitle: 'Analytics',
      pageTitle: 'Analytics',
      action: 'view_outreach_campaigns',

      component: Analytics,
    },
    {
      icon: 'list',
      url: '/tasks',
      menuTitle: 'Tasks',
      pageTitle: 'Tasks Management',
      action: 'view_outreach_contacts',

      component: Tasks,
    },
    {
      icon: 'eye',
      url: '/campaign_monitoring/:id',
      pageTitle: 'Campaign Monitoring',
      action: 'view_outreach_campaigns',

      menuUrl: singleCampaignId
        ? `/campaign_monitoring/${singleCampaignId}`
        : undefined,
      menuTitle: singleCampaignId ? 'Monitoring' : undefined,

      component: CampaignMonitoring,
    },
    {
      icon: 'eye',
      url: '/campaign_monitoring',
      pageTitle: 'Campaign Monitoring',
      action: 'view_outreach_campaigns',
      menuTitle: !singleCampaignId ? 'Monitoring' : undefined,

      component: GeneralMonitoring,
    },
    {
      icon: 'rocket',
      url: '/campaigns',
      menuTitle: 'Campaigns',
      pageTitle: 'Campaigns Management',
      action: 'view_outreach_campaigns',

      component: Campaigns,
    },
    {
      url: '/campaigns/:id/webhooks',
      pageTitle: 'Campaign Webhooks',
      action: 'view_outreach_campaigns',
      component: CampaignWebhooks,
    },
    {
      url: '/campaigns/:id/dialer-schedule',
      pageTitle: 'Phone calling Settings & Limitations',
      action: 'manage_outreach_campaigns',
      component: DialerScheduleSettings,
    },
    {
      url: '/campaigns/:id/contact-states',
      pageTitle: 'Contact States & Actions',
      action: 'manage_outreach_campaigns',
      component: ContactStateSettings,
    },
    {
      url: '/campaigns/:id/caller-agents',
      pageTitle: 'Caller Agents (A/B Testing)',
      action: 'manage_outreach_campaigns',
      component: CampaignCallerAgents,
    },
    {
      icon: 'people',
      url: '/contacts_management',
      menuTitle: 'Contacts',
      pageTitle: 'Contacts Management',
      action: 'view_outreach_contacts',

      component: Contacts,
    },
    {
      icon: 'plus',
      url: '/contacts_import',
      menuTitle: 'Import Contacts',
      action: 'manage_outreach_contacts',

      component: ContactsImport,
    },
    // {
    //   url: '/contacts_management/unified_communication_history/:id',
    //   pageTitle: 'Unified Communication History',
    //   action: 'view_outreach_contacts',

    //   component: MessagesForContact,
    // },
    {
      url: '/campaigns/system_prompts/:id',
      pageTitle: 'System Prompts List',
      action: 'view_outreach_campaigns',

      component: PromptsForCampaign,
    },
    {
      icon: 'document',
      url: '/organization_secrets',
      menuTitle: 'Organization Secrets',
      action: 'manage_outreach_campaigns',

      component: OrganizationSecrets,
    },
  ];
};
